import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { AuthSignupComponent } from './components/auth-signup/auth-signup.component';
import { AuthSigninComponent } from './components/auth-signin/auth-signin.component';
import { SharedModule } from '../shared/shared.module';
import { AuthResetpassComponent } from './components/auth-resetpass/auth-resetpass.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthAcceptInvitationComponent } from './components/auth-accept-invitation/auth-accept-invitation.component';
import { AuthOtpComponent } from './components/auth-otp/auth-otp.component';
import { AuthPasswordInputsComponent } from './components/auth-password-inputs/auth-password-inputs.component';
import { StoreModule } from '@ngrx/store';
import * as AuthReducer from './store/reducers/auth.reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './store/effects/auth.effects';
import { environment } from 'src/environments/environment';
import { AuthGoogleComponent } from './components/auth-google/auth-google.component';

@NgModule({
  declarations: [
    AuthSignupComponent,
    AuthSigninComponent,
    AuthResetpassComponent,
    AuthAcceptInvitationComponent,
    AuthOtpComponent,
    AuthPasswordInputsComponent,
    AuthGoogleComponent
  ],
  exports: [
    AuthGoogleComponent
  ],
  imports: [
    FormsModule,
    SharedModule,
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    StoreModule.forFeature(
      AuthReducer.authKey,
      AuthReducer.authReducer
    ),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    EffectsModule.forFeature([
      AuthEffects
    ]),
  ],
})
export class AuthModule { }
